import type { HeadCell } from "./types";
import {
  TABLE_BODY_CELL_SX,
  TABLE_HEADER_CELL_SX,
  ROW_NUMBER_WIDTH_PCT as SHARED_ROW_NUMBER_WIDTH_PCT,
} from "../../../../components/ui";

export const COLUMN_COUNT = 9;
export const ROW_NUMBER_WIDTH_PCT = SHARED_ROW_NUMBER_WIDTH_PCT;

export const HEAD_CELLS: HeadCell[] = [
  { id: "caseName", label: "Case Name", widthPct: 18 },
  { id: "stage", label: "Stage", widthPct: 12 },
  { id: "raa", label: "RAA", widthPct: 8 },
  { id: "ap", label: "AP", widthPct: 8 },
  { id: "complaintFiledDate", label: "Complaint Filed", widthPct: 12 },
  { id: "formByDate", label: "Form By", widthPct: 12 },
  { id: "daysPastFormBy", label: "Days Past", widthPct: 10 },
  { id: "lloExpiration", label: "LLO Expiration", widthPct: 12 },
];

export { TABLE_BODY_CELL_SX, TABLE_HEADER_CELL_SX };

export const OVERDUE_ROW_BG = "rgba(254, 226, 226, 0.35)";
